import type { Message, Publisher, Thread, YammerState } from '../../state/types';
import { isNullOrWasDeleted } from '../threadLoad/selectors';
import { findById as findThread, getStatusForId } from '../threads/selectors';

import { findByIdThrows as findPublisher } from './findPublisherSelectors';

type GetSharedMessageId = (state: YammerState, publisherId: Publisher['id']) => Message['id'] | undefined;
export const getSharedMessageId: GetSharedMessageId = (state, publisherId) => {
  const { sharedThreadId, sharedMessageId } = findPublisher(state, publisherId);

  if (sharedMessageId) {
    return sharedMessageId;
  }

  if (sharedThreadId == null) {
    return;
  }

  const thread = findThread(state, sharedThreadId);

  return thread ? thread.threadStarterId : undefined;
};

type GetPublisherSharedMessageIdThrows = (
  state: YammerState,
  publisherId: Publisher['id']
) => Message['id'] | undefined;
export const getPublisherSharedMessageIdThrows: GetPublisherSharedMessageIdThrows = (state, publisherId) => {
  const { sharedMessageId } = findPublisher(state, publisherId);

  return sharedMessageId;
};

type GetPublisherSharedThreadIdThrows = (state: YammerState, publisherId: Publisher['id']) => Thread['id'] | undefined;
export const getPublisherSharedThreadIdThrows: GetPublisherSharedThreadIdThrows = (state, publisherId) => {
  const { sharedThreadId } = findPublisher(state, publisherId);

  return sharedThreadId;
};

type HasUnresolvedSharedMessage = (state: YammerState, publisherId: Publisher['id']) => boolean;
export const hasUnresolvedSharedMessage: HasUnresolvedSharedMessage = (state, publisherId) => {
  const { sharedThreadId } = findPublisher(state, publisherId);

  if (sharedThreadId == null) {
    return false;
  }

  return getStatusForId(state, sharedThreadId) !== 'fulfilled';
};

type HasPrivateOrDeletedSharedMessage = (state: YammerState, publisherId: Publisher['id']) => boolean;
export const hasPrivateOrDeletedSharedMessage: HasPrivateOrDeletedSharedMessage = (state, publisherId) => {
  const { sharedThreadId } = findPublisher(state, publisherId);

  if (sharedThreadId == null) {
    return false;
  }

  return isNullOrWasDeleted(state, sharedThreadId);
};

type HasSharedMessageThatFailedToResolve = (state: YammerState, publisherId: Publisher['id']) => boolean;
export const hasSharedMessageThatFailedToResolve: HasSharedMessageThatFailedToResolve = (state, publisherId) => {
  const { sharedThreadId } = findPublisher(state, publisherId);

  if (sharedThreadId == null || isNullOrWasDeleted(state, sharedThreadId)) {
    return false;
  }

  return getStatusForId(state, sharedThreadId) === 'rejected';
};
